import styled from '@emotion/styled';

export const Container = styled.div`
    width: 100%;
    padding: ${({ theme }) => theme.spacing[4]};

    > div {
        margin-bottom: ${({ theme }) => theme.spacing[4]};
    }
`;

export const IntegrationSection = styled.div`
    display: flex;
    flex-direction: row;
    padding: 0;
    font-family: ${({ theme }) => theme.font.family};

    ${({ theme }) => theme.breakpoints.mobile} {
        flex-direction: column;
    }
`;

export const IntegrationLeft = styled.div`
    flex: 0 0 30%;
    margin-left: 20px;
    margin-top: 30px;
    margin-right: 10px;

    h2 {
        font-size: 22px;
        color: #4b4646;
        margin-bottom: 10px;
    }
`;

export const IntegrationRight = styled.div`
    flex: 0 0 68%;
    min-height: 190px;
    display: flex;
    flex-wrap: wrap;
    padding: 12px;
    padding-block-end: 20px;
`;

export const IntegrationDescription = styled.div`
    font-size: 12px;
    margin-top: 10px;
    color: #4b4646;
`;

export const WebhookContainer = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 150px);
    grid-auto-flow: column;
    grid-auto-columns: 150px;
    gap: 22px;
    flex: 1;
    width: 100%;
    overflow-x: auto;

    > div {
        margin: 0;
        width: auto;

        height: 150px;
    }
`;

export const IntegrationCard = styled.div`
    width: 150px;
    height: 150px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #eeeeee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin: 0;

    &:hover {
        background-color: #eeeeee;
    }

    img {
        width: 60px;
        height: 40px;
        object-fit: contain;
        margin-bottom: 10px;
    }

    .integration-title {
        font-size: 12px;
        font-weight: 500;
        text-align: center;
        color: #4b4646;
        margin-bottom: 8px;
    }

    .configurations {
        position: absolute;
        bottom: 8px;
        font-size: 10px;
        font-style: italic;
        line-height: 1.7;
        color: #9b9b9b;
        display: flex;
        align-items: center;
        gap: 4px;

        .icon-check2 {
            color: #28a745;
        }

        .icon-close2 {
            color: #dc3545;
        }
    }
`;

export const IntegrationsGrid = styled.div`
    display: grid;
    grid-template-columns: repeat(auto-fill, 150px);
    grid-template-rows: 150px;
    gap: 22px;
    flex: 1;
    width: 100%;

    > div {
        margin: 0;
        width: auto;
    }
`;

export const WebhookCard = styled.div<{ isSystem?: boolean }>`
    width: 150px;
    height: 150px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #eeeeee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin: 0;
    opacity: ${({ isSystem }) => (isSystem ? 0.6 : 1)};

    &:hover {
        background-color: #eeeeee;
    }

    img {
        width: 40px;
        height: 40px;
    }

    .configurations {
        position: absolute;
        bottom: 8px;
        font-size: 10px;
        font-style: italic;
        line-height: 1.7;
        color: #9b9b9b;
    }
`;

export const SystemBadge = styled.span`
    position: absolute;
    top: 8px;
    right: 8px;
    background-color: #6c757d;
    color: #ffffff;
    font-size: 10px;
    font-weight: 500;
    padding: 2px 6px;
    border-radius: 4px;
`;

export const AddWebhookCard = styled.div`
    width: 150px;
    height: 150px;
    border-radius: 8px;
    background-color: #ffffff;
    box-shadow: 0 2px 0 0 rgba(0, 0, 0, 0.1);
    border: solid 1px #eeeeee;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    margin: 0;

    &:hover {
        background-color: #eeeeee;
    }

    svg {
        font-size: 30px;
    }
`;

export const StretchedCard = styled.div`
    display: block;
    width: 100%;
    flex: 1;
    background-color: ${({ theme }) => theme.color.white100};
    border: 1px solid ${({ theme }) => theme.color.grey200};
    border-radius: ${({ theme }) => theme.radius.main};
    padding: ${({ theme }) => theme.spacing[4]};
`;

export const WebhookImage = styled.img`
    width: 40px;
    height: 40px;
`;
